import dayjs from "dayjs";

import { IStockMovement } from "@/interfaces/sku-movement.interfaces";
import { SkuMovementMessages } from "@/messages/sku/sku-movement.messages";

type UseStockMovementDataReturn = Omit<Partial<IStockMovement>, "type"> & {
  formattedType: string;
  formattedQuantity: string;
  formattedMovementDate: string;
};

type UseStockMovementDataProps = {
  movement: IStockMovement;
  messages: SkuMovementMessages;
};

function useStockMovementData({
  movement,
  messages,
}: UseStockMovementDataProps): UseStockMovementDataReturn {
  const { type, quantity, movementDate, ...rest } = movement;

  const formattedType = type === "ENTRY" ? messages.entryOption : messages.exitOption;
  const formattedQuantity = quantity.toString();
  const formattedMovementDate = movementDate
    ? dayjs(movementDate).format("DD/MM/YYYY HH:mm:ss")
    : "-";

  return { ...rest, formattedType, formattedQuantity, formattedMovementDate };
}

export default useStockMovementData;
